import React, {useEffect, useState} from 'react';
import moment from 'moment';
import { makeStyles } from '@material-ui/core/styles';
import {MyMess} from '../App'

const useStyles = makeStyles((theme) => ({
  wrapper : {
    background: 'black',
    display: 'inline-block',
    margin: '10px',
    minWidth: '100px',
    padding: '20px 0',
  },
  card : {
    background: '#272c34',
    display: 'inline-block',
    margin: '10px',
    minWidth: '100px',
    padding: '20px 0',
  },
  value:{
    textAlign: 'center',
    color: '#f50057',
    fontSize: '2rem',
  },
  unit:{
    textAlign: 'center',
    fontSize: '1rem',
    color: 'white',
    textTransform: 'capitalize'
  },
  label: {
    paddingLeft: '10px',
    fontSize: '1.2rem',
    color: 'white'
  }
}))

const Countdown = ({ endDate, label, footerMessage }) => {
 
  const classes = useStyles();
  const unixEndDate = Number(moment(endDate).format('X'));

    let timer = null;
    
    const [countdown, setCountdown] = useState({
        days: '',
        hours: '',
        mins: '',
        secs: ''
      });


      useEffect(() => {
        startCountdown({unixEndDate});

        return function cleanup() {
          if (timer) {
            clearInterval(timer);
            timer = null;
          }
        }
      });
      const startCountdown = (endDate) => {
        if (timer) {
          clearInterval(timer);
          timer = null;
        }
       
        if (endDate.unixEndDate !== '') {
          timer = setInterval(() => playTimer(endDate.unixEndDate), 1000);
        }
        
      }

    const playTimer = (unixEndDate) => {
        const distance = unixEndDate - moment().format('X');
    
        if (distance > 0) {
            setCountdown({
              days: parseInt(distance / (60 * 60 * 24), 10),
              hours: parseInt(distance % (60 * 60 * 24) / (60 * 60), 10),
              mins: parseInt(distance % (60 * 60) / (60), 10),
              secs: parseInt(distance % 60, 10)
            });
        }
        else {
          clearInterval(timer);
          timer = null;
        }
      }

   

  return (
    <div className={classes.wrapper}>
      <div className={classes.label}>{label}</div>
      <div className={classes.card}>
        <div className={classes.value}>
          {countdown.days} 
          <span className={classes.unit}> {MyMess.countdown.days}</span>
        </div>
        {/* <div className={classes.unit}>日</div> */}
      </div>
      <div className={classes.card}>
        <div className={classes.value}>
          {countdown.hours} 
          <span className={classes.unit}> {MyMess.countdown.hours}</span>
          </div>
        {/* <div className={classes.unit}>Hours</div> */}
      </div>
      <div className={classes.card}>
        <div className={classes.value}>
          {countdown.mins} 
          <span className={classes.unit}> {MyMess.countdown.mins}</span>
        </div>
        {/* <div  className={classes.unit}>Mins</div> */}
      </div>
      <div className={classes.card}>
        <div className={classes.value}>
          {countdown.secs} 
          <span className={classes.unit}> {MyMess.countdown.secs}</span>
        </div>
        {/* <div  className={classes.unit}>Secs</div> */}
      </div>
      <div  className={classes.unit}>{footerMessage}</div>

    </div>
  );
}

export default Countdown;